import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { WIDGET_STATUS, WidgetInfo } from '@shared/widgets/core/widgets.types';
import { ExportAsImageHeaderOptions } from '@shared/components/widget';
import { FullscreenViewService } from '@main/shared/widget-full-screen-view/services/fullscreen-view.service';
import { EntityHelpers } from '@main/helpers/entity.helpers';
import { MenuSchema } from '@main/dashboards/interfaces';
import { WIDGET_VIEW_MODE } from '@main/widgets/shared/widget.types';
import { Helpers } from './widget-card.helpers';

@Component({
    selector: 'widget-card',
    templateUrl: './widget-card.component.html',
    styleUrls: ['./widget-card.component.scss'],
})
export class WidgetCardComponent implements OnInit {
    @Input() title: string;
    @Input() widgetInfo: WidgetInfo;
    @Input() status: WIDGET_STATUS;
    @Input() hasData: boolean;
    @Input() extraExportImageOptions: ExportAsImageHeaderOptions;

    @Input() showHeader = true;
    @Input() footer: boolean;
    @Input() contentCls: string;

    @Output() menuAction = new EventEmitter<MenuSchema>();

    @HostBinding('class.full-screen-view-mode')
    get fullScreenViewMode(): boolean {
        return this.fullScreenViewService.isFullscreenView;
    }

    get showMenu(): boolean {
        return this.widgetInfo.data.viewMode === WIDGET_VIEW_MODE.DASHBOARD && !this.fullScreenViewMode;
    }

    get showAdvancedInfo(): boolean {
        return this.widgetInfo.data.viewMode === WIDGET_VIEW_MODE.DASHBOARD;
    }

    get canDrag(): boolean {
        return this.widgetInfo.data.canDrag;
    }

    get showContent(): boolean {
        return this.hasData && this.status !== WIDGET_STATUS.LOADING;
    }

    entityTypeName: string;

    menuSchema: MenuSchema[] = [];

    constructor(private fullScreenViewService: FullscreenViewService) {}

    onMenuEvent(event: MenuSchema): void {
        this.menuAction.emit(event);
    }

    ngOnInit() {
        const { entityType, canDelete, canDuplicate } = this.widgetInfo.data;

        this.entityTypeName = EntityHelpers.getEntityInfo(entityType).text.fewUpper;
        this.menuSchema = Helpers.generateItemMenuSchema(canDelete, canDuplicate);
    }
}
